<script lang="ts" setup>
import { Dibs } from "../../../../types/dibs";
import { onMounted, onUnmounted, ref, watch } from "vue";
import { useNetsEasyCheckoutStore } from "../../stores/netsEasyCheckoutStore";
import { createPayment } from "../../utils/API/NetsEasy/netsEasyAPI";
import { CheckoutSteps } from "../../services/models/checkout.models";
import { useCheckoutStateStore } from "./stores/checkoutStateStore";
import GtmService from "../../services/gtm.service";
import CheckoutHelpers from "../../../../helpers/checkoutHelpers";
import { Log } from "../../utils/API/Logging/LoggingAPI";
import { useShoppingCartStore } from "../shoppingCart/stores/shoppingCartStore";
import { useCustomerInformationStore } from "./stores/customerInformationStore";
import { useDeliveryInformationStore } from "./stores/deliveryInformationStore";

const LANGUAGE_TAG = "nb-NO";

const shoppingCartStore = useShoppingCartStore();
const deliveryInformationStore = useDeliveryInformationStore();
const customerInformationStore = useCustomerInformationStore();
const checkoutStateStore = useCheckoutStateStore();
const netsEasyCheckoutStore = useNetsEasyCheckoutStore();
const paymentContainer = ref<HTMLDivElement | null>(null);
const checkout = ref<Dibs.Checkout | null>(null);

const props = defineProps<{
  isActive?: boolean;
}>();

const setupEventHandlers = () => {
  checkout.value?.on("pay-initialized", (paymentId) => {
    checkout.value?.send("payment-order-finalized", true);
  });

  checkout.value?.on("payment-completed", (response) => {
    shoppingCartStore.clear();
    deliveryInformationStore.clear();
    customerInformationStore.clear();
    checkoutStateStore.setPaymentId("");

    if (!response.paymentId) {
      Log({
        LogLevel: "Error",
        Message: `Payment completed without a paymentId`,
      });
    } else {
      Log({
        LogLevel: "Information",
        Message: `Payment completed with paymentId: "${response.paymentId}"`,
      });
    }

    window.location.href = `${checkoutStateStore.receiptPageUrl}?paymentId=${response.paymentId}`;
  });
};

onMounted(async () => {
  let paymentId = checkoutStateStore.paymentId;

  if (!paymentId) {
    try {
      const data = await createPayment();
      if (data.paymentId) paymentId = data?.paymentId;
      Log({
        LogLevel: "Error",
        Message: `Could not create payment: "${data.errorMessage}"`,
      })
      // TODO: handle error if paymentId is not returned
    } catch (error) {
      Log({
        LogLevel: "Error",
        Message: `Could not create payment": ${error}`,
      });
    }
  }

  const checkoutOptions = {
    checkoutKey: checkoutStateStore.netsEasyApiCheckoutKey,
    paymentId: paymentId,
    containerId: paymentContainer.value?.id,
    language: LANGUAGE_TAG,
  };

  checkout.value = new window.Dibs!.Checkout(checkoutOptions);
  setupEventHandlers();
});

onUnmounted(() => {
  netsEasyCheckoutStore.checkout?.cleanup();
});
</script>

<template>
  <div class="checkout-payment">
    <div ref="paymentContainer" id="paymentContainer"></div>
  </div>
</template>
